import { Trail } from './trail.interface';

export const FireRoads: Trail[] = [
  {
    code: 'empalme',
    name: 'Empalme',
    description: 'Brecha principal de la meseta. Los domingos la cierran para bicicletas a partir de las 10:00AM.',
    walk_up: {
      difficulty: 1,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 1,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 1,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 1,
      banned: false,
      description: ''
    }
  },
  {
    code: 'epazote',
    name: 'Epazote',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 2,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 2,
      banned: false,
      description: ''
    }
  },
  {
    code: 'moras',
    name: 'Las Moras',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 2,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 2,
      banned: false,
      description: ''
    }
  },
  {
    code: 'deslavada',
    name: 'Deslavada',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 4,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: false,
      description: ''
    }
  },
  {
    code: 'chile',
    name: 'Del Chile',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 3,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 2,
      banned: true,
      description: ''
    }
  },
  {
    code: 'pinal',
    name: 'Pinal',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 3,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 3,
      banned: false,
      description: ''
    }
  },
  {
    code: 'san-agustin',
    name: 'San Agustín',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 2,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 2,
      banned: false,
      description: ''
    }
  }
];



// WEBPACK FOOTER //
// /Users/mundofr/GitHub/Angle/ChipinqueTrails/src/app/fireroads.data.ts